import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PaymentLinkData } from 'voxloud-types/dist/models';

@Injectable({
  providedIn: 'root'
})
export class PaymentLinkService {

  constructor(
    private http: HttpClient
  ) { }

  public generatePaymentUpdateLink(companyId: number, createdBy: string): Observable<PaymentLinkData> {
    return this.http.post<PaymentLinkData>(`${environment.apiEndpoint}/api/v1/payment-links`, {
      companyId,
      createdBy
    });
  }

  public getPaymentLinkInfo(linkId: string): Observable<PaymentLinkData> {
    return this.http.get<PaymentLinkData>(`${environment.apiEndpoint}/api/v1/payment-links/${linkId}`);
  }
}